module.exports = __webpack_public_path__ + "img/camion4.213d7861.jpg";